/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { memo } from 'react';

import './footer.css';

const Footer = ({ targetUrl }) => (
  <footer>
    <div className='footer-links'>
      <a
        className='font-weight-bold'
        target='_blank'
        rel='noopener noreferrer'
        href={`https://developers.google.com/speed/pagespeed/insights/?url=${targetUrl}`}>
        PageSpeed Insights report
      </a>
      <a
        className='font-weight-bold'
        target='_blank'
        rel='noopener noreferrer'
        href={`https://googlechrome.github.io/lighthouse/viewer/?psiurl=${targetUrl}&category=accessibility&category=performance&category=pwa&category=best-practices&category=seo`}>
        Lighthouse report
      </a>
    </div>
  </footer>
);

export default memo(Footer);
